export enum OptionSelectionType {
    // [Description("Auto Accept")] 
    AutoAccept = 1,
    // [Description("Accept/Decline")] 
    AcceptOrDecline = 2,
    // [Description("Partial Accept/Decline")] 
    PartialAcceptOrDecline = 3,
}